import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { SectionHeading } from '../components/SectionHeading';
import { PROBLEMS } from '../data/site';
export function ProblemRecognition() {
  return <section className="w-full bg-sand py-20 lg:py-28" data-id="element-608">
      <div className="mx-auto max-w-7xl px-5 lg:px-8" data-id="element-609">
        <SectionHeading eyebrow="Where systems break" title="Where geology systems sometimes break." body="Most mine geology problems are not isolated technical issues. They are failures in how the system operates — and they usually show up in one of these six places." data-id="element-610" />

        <div className="mt-12 grid items-stretch gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-611">
          {PROBLEMS.map((p, i) => <motion.div key={p.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          delay: i * 0.06
        }} className="relative flex h-full flex-col overflow-hidden rounded-xl border border-charcoal/10 bg-cream p-6 shadow-card" data-id="element-612">
              <span className="absolute inset-y-0 left-0 w-1.5" style={{
            backgroundColor: p.relatedColor
          }} aria-hidden data-id="element-613" />
              <div className="flex items-center gap-3" data-id="element-614">
                <span className="text-2xl font-black tabular-nums" style={{
              color: p.relatedColor
            }} data-id="element-615">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <span className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-wide" style={{
              color: p.relatedColor
            }} data-id="element-616">
                  <span className="h-2 w-2 rounded-sm" style={{
                backgroundColor: p.relatedColor
              }} data-id="element-617" />
                  {p.related}
                </span>
              </div>
              <h3 className="mt-3 text-lg font-bold leading-snug text-charcoal" data-id="element-618">
                {p.title}
              </h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-warmgray" data-id="element-619">
                {p.body}
              </p>
            </motion.div>)}
        </div>

        <p className="mt-10 text-center" data-id="element-620">
          <Link to="/framework" className="inline-flex items-center gap-1.5 text-sm font-bold text-charcoal underline decoration-yellow decoration-2 underline-offset-4" data-id="element-621">
            See how the framework holds the system together →
          </Link>
        </p>
      </div>
    </section>;
}